import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { FormOperacionCorporate, schemaFormOperacionCorporate } from "./types/types"
import { zodResolver } from "@hookform/resolvers/zod"
import { HttpCorporate } from "./api/httpCorporate"
import { OperacionCorporateFields } from "./types/fields"
import toast from "react-hot-toast"
import { Box, Grid } from "@mui/material"
import { z } from "src/lib"
import { useCallback, useContext, useEffect, useState } from "react"
import { useLoader } from "src/hooks/useLoader"
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema"
import {
  SeccionCorporateCuentasNuevo,
} from "./components/SeccionCorporateDetalleNuevo";
import SeccionCorporateDatosOperacion from "./components/SeccionCorporateDatosOperacion";
import navigation from "src/navigation/vertical"
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion"


export const CuentaProvisionalFields = {
  IdProvisional: 'idProvisional',
  NroCuenta: 'nroCuenta',
  RazonSocial: 'razonSocial',
  CodMoneda: 'codMoneda',
  ImporteConcertacion: 'importe_Concertacion',
  ImporteDPV: 'importe_DPV',
  ImporteFOP: 'importe_FOP',
  BitEnvio: 'bitEnvio'
} as const

export const cuentaProvisional = z
  .object({
    [CuentaProvisionalFields.IdProvisional]: z.string(),
    [CuentaProvisionalFields.NroCuenta]: z.string().min(1, 'Required'),
    [CuentaProvisionalFields.RazonSocial]: z.string().min(1, 'Required'),
    [CuentaProvisionalFields.CodMoneda]: z.number(),
    [CuentaProvisionalFields.ImporteConcertacion]: z.number(),
    [CuentaProvisionalFields.ImporteDPV]: z.number(),
    [CuentaProvisionalFields.ImporteFOP]: z.number(),
  })

export type CuentaProvisional = z.infer<typeof cuentaProvisional>


type NuevoSistemaCorporateProps = {
  codSistemaPrincipal: number
}

export const NuevoSistemaCorporate = (props: NuevoSistemaCorporateProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const [cuentasProvisionales, setCuentasProvisionales] = useState<CuentaProvisional[]>([])

  const formMethods = useForm<FormOperacionCorporate>({
    resolver: zodResolver(schemaFormOperacionCorporate),
    defaultValues: {
      [OperacionCorporateFields.FechaAprobacion]: new Date()
    }
  })

  const alCrearOperacionCorporate = useCallback((data: FormOperacionCorporate, selected: number) => {
    if (!cuentasProvisionales.length) {
      toast.error('Debe cargar por lo menos una cuenta para enviar la operación.');
      
      return;
    }

    const payload = {
      ...data,
      [OperacionCorporateFields.Cuentas]: cuentasProvisionales,
      [OperacionCorporateFields.BitEnvio]: selected !== 1,
      [OperacionCorporateFields.CodPais]: props.codSistemaPrincipal
    };

    submitOperacion(payload, {
      apiCall: HttpCorporate.post,
      successMessage: 'Guardado correctamente.',
      errorMessage: 'Error al guardar.'
    });
  }, [cuentasProvisionales, props.codSistemaPrincipal, submitOperacion]);

  const { setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    const onSend = () => formMethods.handleSubmit(data => alCrearOperacionCorporate(data, 2))
    setSendPromise(onSend)
  }, [formMethods, alCrearOperacionCorporate])

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionCorporateDatosOperacion
            formMethods={formMethods}
            codSistemaPrincipal={props.codSistemaPrincipal}
            codSistema={codSistema}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionCorporateCuentasNuevo
            idPais={props.codSistemaPrincipal}
            cuentasProvisionales={cuentasProvisionales}
            setCuentasProvisionales={setCuentasProvisionales}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
